import axios from 'axios'

const STORAGE_KEY = 'webinar_admin_key'

const api = axios.create({
  baseURL: '/api/webinar-admin',
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const key = localStorage.getItem(STORAGE_KEY)
  if (key) {
    config.headers['X-Webinar-Admin-Key'] = key
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEY)
      if (!window.location.pathname.endsWith('/inscriptions-admin/login')) {
        window.location.href = '/inscriptions-admin/login'
      }
    }
    return Promise.reject(error)
  },
)

export interface WebinarRegistration {
  id: string
  nom: string
  fonction: string
  institution: string
  pays: string
  email: string
  telephone: string
  created_at: string | null
  reminder_sent_at: string | null
}

export interface WebinarListResponse {
  items: WebinarRegistration[]
  total: number
  reminder_sent_total: number
  zoom_url_configured: boolean
}

export interface SendZoomLinksResponse {
  sent: number
  failed: number
  failures?: Array<{ email: string; reason: string }>
  force?: boolean
  message?: string
}

export const webinarStorage = {
  getKey: () => localStorage.getItem(STORAGE_KEY),
  setKey: (key: string) => localStorage.setItem(STORAGE_KEY, key),
  clearKey: () => localStorage.removeItem(STORAGE_KEY),
}

export const checkWebinarAdminKey = async (key: string): Promise<boolean> => {
  try {
    await axios.get('/api/webinar-admin/check', {
      headers: { 'X-Webinar-Admin-Key': key },
    })
    return true
  } catch {
    return false
  }
}

export const listRegistrations = async (): Promise<WebinarListResponse> => {
  const response = await api.get('/registrations')
  return response.data
}

export const sendZoomLinks = async (
  options: { ids?: string[]; force?: boolean } = {},
): Promise<SendZoomLinksResponse> => {
  const { ids, force = false } = options
  const body = ids && ids.length > 0 ? { ids } : null
  const response = await api.post('/send-zoom-links', body, {
    params: { force },
  })
  return response.data
}
